import * as ProjectModule from './modules/Project';
import * as AuthModule from './modules/Auth';

const Client = {
  ...ProjectModule,
  ...AuthModule,
};

export default Client;
